import { Box } from '@mui/material';
import { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';

const LoginSuccessful: React.FC = () => {
    const [remainingTime, setRemainingTime] = useState(2);
    const [redirectNow, setRedirectNow] = useState(false);

    useEffect(() => {
        const timer = setInterval(() => {
            if (remainingTime > 0) {
                setRemainingTime(remainingTime - 1);
            }
        }, 1000);

        return () => {
            clearInterval(timer);
        };
    }, [remainingTime]);

    setTimeout(() => setRedirectNow(true), 2000);
    return (
        <Box
            m={{
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'column',
                m: 5,
            }}
        >
            <h2>Login successful</h2>
            <h3>Redirecting in {remainingTime} seconds</h3>
            {redirectNow && <Navigate to="/" />}
        </Box>
    );
};

export default LoginSuccessful;
